export default object => style => {
  if (typeof object === 'function') {
    return object(style);
  }

  return object[style];
};



// WEBPACK FOOTER //
// ./lib/convert/html/draft-convert-html/util/styleObjectFunction.js